module.exports.CONSOLE_VERSION = '6.9.0.19'
module.exports.WI_CONSOLE_VERSION = '1.3.0.146'
